import React, { useEffect } from 'react'
import { useSystemStatus } from '../Context/SystemStatusContext'
import Icon from '@embracesbs/component-icon'

// Full-width bar fixed at the very top, above all three columns. While active
// it adds the `maintenance-active` class to <body>, which pushes the whole app
// down (see index.css) so no buttons or text are overlapped.
const MaintenanceBanner: React.FC = () => {
  const { maintenance } = useSystemStatus()

  useEffect(() => {
    document.body.classList.toggle('maintenance-active', maintenance.enabled)
    return () => document.body.classList.remove('maintenance-active')
  }, [maintenance.enabled])

  if (!maintenance.enabled) return null

  const message = maintenance.message || 'Maintenance in progress — tenant actions are temporarily disabled.'

  return (
    <div
      role='alert'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'var(--maintenance-height)',
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        padding: '0 16px',
        boxSizing: 'border-box',
        background: '#c0392b',
        color: '#ffffff',
        fontSize: '13px',
        fontWeight: 700,
        letterSpacing: '0.02em',
        fontFamily: "'F-Default', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      }}
    >
      <Icon iconName='Wrench' size={16} color='#ffffff' />
      <span>{message}</span>
      <Icon iconName='Wrench' size={16} color='#ffffff' />
    </div>
  )
}

export default MaintenanceBanner
